import React from 'react'
import Typography from '@material-ui/core/Typography'

const FileInput = ({
  className,
  style,
  fileInputRef,
  thumbnails,
  onChange,
  ...props
}) => (
  // eslint-disable-next-line
  <label
    style={{
      marginBottom: 5,
      cursor: 'pointer',
      overflow: 'hidden',
      position: 'relative',
      float: 'left',
      width: '100%',
      boxSizing: 'border-box',
    }}
  >
    <Typography component="div" className={className} style={style}>
      <div
        style={{
          color: '#285978',
          fontWeight: 700,
          padding: 15,
          textAlign: 'center',
          border: '2px dashed grey',
        }}
      >
        Select Images
      </div>
    </Typography>
    <input
      id="fileInputRef"
      ref={fileInputRef}
      type="file"
      onChange={onChange}
      style={{
        cursor: 'inherit',
        display: 'block',
        filter: 'alpha(opacity = 0)',
        minWidth: '100%',
        minHeight: '100%',
        opacity: 0,
        position: 'absolute',
        right: 0,
        textAlign: 'right',
        top: 0,
      }}
      multiple
      {...props}
    />
  </label>
)

export default FileInput



// WEBPACK FOOTER //
// ./src/cms/widgets/S3Thumbnails/FileInput.js